export default __webpack_public_path__ + "static/media/icon_cashsweep5.2d808a60.png";